var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.549,
    height: 18.717,
    viewBox: "0 0 20.549 18.717",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(0.907 0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M23.747,33.357l9.437-6.782,9.3,6.782",
    transform: "translate(-23.747 -26.575)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M52.727,74.933V69.026a2.845,2.845,0,0,1,4.852,0v5.907",
    transform: "translate(-45.983 -58.104)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M38.588,30.381V26.575H40.7v2.471",
    transform: "translate(-35.135 -26.575)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M45.4,51.735V61.71A1.587,1.587,0,0,1,43.814,63.3H30.8A1.587,1.587,0,0,1,29.21,61.71V51.749",
    transform: "translate(-27.939 -45.88)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC41NDkiIGhlaWdodD0iMTguNzE3IiB2aWV3Qm94PSIwIDAgMjAuNTQ5IDE4LjcxNyI+CiAgPGcgaWQ9Ikdyb3VwXzg4MiIgZGF0YS1uYW1lPSJHcm91cCA4ODIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTA3IDAuNjUpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzkxOSIgZGF0YS1uYW1lPSJQYXRoIDkxOSIgZD0iTTIzLjc0NywzMy4zNTdsOS40MzctNi43ODIsOS4zLDYuNzgyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjMuNzQ3IC0yNi41NzUpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjEuMyIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTIwIiBkYXRhLW5hbWU9IlBhdGggOTIwIiBkPSJNNTIuNzI3LDc0LjkzM1Y2OS4wMjZhMi44NDUsMi44NDUsMCwwLDEsNC44NTIsMHY1LjkwNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ1Ljk4MyAtNTguMTA0KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxLjMiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzkyMSIgZGF0YS1uYW1lPSJQYXRoIDkyMSIgZD0iTTM4LjU4OCwzMC4zODFWMjYuNTc1SDQwLjd2Mi40NzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNS4xMzUgLTI2LjU3NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMS4zIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85MjIiIGRhdGEtbmFtZT0iUGF0aCA5MjIiIGQ9Ik00NS40LDUxLjczNVY2MS43MUExLjU4NywxLjU4NywwLDAsMSw0My44MTQsNjMuM0gzMC44QTEuNTg3LDEuNTg3LDAsMCwxLDI5LjIxLDYxLjcxVjUxLjc0OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI3LjkzOSAtNDUuODgpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjEuMyIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };